import type { ListBenefitPlanGroupsParams, LoadCoverageParams } from "./types";

/**
 * Query keys for React Query cache management.
 *
 * Extracted into a standalone file so that both query hooks and mutation
 * hooks can import keys without pulling in heavy dependencies.
 */
export const queryKeys = {
  rfp: (rfpId: string) => ["rfp", rfpId] as const,
  rfpNotes: (rfpId: string) => ["rfp-notes", rfpId] as const,
  coverageNotes: (rfpId: string) => ["coverage-notes", rfpId] as const,
  coverage: (params: LoadCoverageParams) =>
    ["coverage", params.coverageType, params.rfpId] as const,
  coverageSummary: (ecoRfpId: string) =>
    ["coverage-summary", ecoRfpId] as const,
  /** Prefix key that matches ALL benefitPlanGroups queries (any rfpId / coverageType / productType). */
  benefitPlanGroupsAll: ["benefitPlanGroups"] as const,
  benefitPlanGroups: (params: ListBenefitPlanGroupsParams) =>
    [
      "benefitPlanGroups",
      params.rfpId,
      params.coverageType,
      params.productType,
    ] as const,
  fieldComments: (benefitPlanId: string) =>
    ["fieldComments", benefitPlanId] as const,
  benefitClasses: (rfpId: string) => ["benefit-classes", rfpId] as const,
  /** Candidate "Current Carrier - Policy" options for a coverage (ADR 10.22). */
  candidatePolicies: (coverageId: string, planType?: string) =>
    ["candidatePolicies", coverageId, planType ?? null] as const,
};
